/**
 * OnboardingSuccess.tsx
 * Final screen shown after successfully completing the onboarding flow.
 * Shows intro video and "Start Chatting" button to dismiss.
 */
import React from "react";
import { View, ScrollView, StyleSheet } from "react-native";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import CustomText from "../../common/general/CustomText/CustomText";
import { CompanionVideoPlayer } from "../shared/CompanionVideoPlayer";
import { colors, spacing, spacingStyles } from "../../../styles/design-system";

export interface OnboardingSuccessProps {
  onComplete: () => void;
}

function OnboardingSuccess({ onComplete }: OnboardingSuccessProps) {

  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      <View style={[spacingStyles.pLg]}>
        {/* Header */}
        <View style={styles.header}>
          <CustomText
            text="companion_onboarding_success_title"
            size="xl"
            weight="bold"
            style={[{ color: colors.grey[900], marginBottom: spacing.xs }]}
          />
          <CustomText
            text="companion_onboarding_success_video_hint"
            size="m"
            style={[{ color: colors.grey[600] }]}
          />
        </View>

        {/* Video Player */}
        <CompanionVideoPlayer />

        {/* Settings Hint */}
        <View style={styles.settingsHint}>
          <CustomText
            text="companion_onboarding_success_settings_hint"
            size="m"
            style={[{ color: colors.grey[600], textAlign: "center" }]}
          />
        </View>

        {/* Start Button */}
        <View style={styles.buttonContainer}>
          <CustomButton
            text="buttons.companion_onboarding_success_cta"
            onPress={onComplete}
            styleType="primary"
            style={{ width: "100%" }}
          />
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    alignItems: "center",
    marginBottom: spacing.sm,
  },
  settingsHint: {
    marginVertical: spacing.lg,
  },
  buttonContainer: {
    marginTop: spacing.sm,
  },
});

export default OnboardingSuccess;
